module.exports = __webpack_public_path__ + "assets/img/2.3a8626e0.webp";